import {
  AppMenuGroup,
  IAppMenuItem,
} from '@/components/system/Layout/LayoutWebCore/WebCoreAppMenus';
import LanguageSwitcher from '@/components/system/LanguageSwitcher';
import { Gamepad2, Crown, Flame, Box, Dice3, Share2, Gem } from 'lucide-react';
import { SupportAgent, RocketLaunch } from '@mui/icons-material';
import { CasinoIcon, SportIcon } from './styles';
import busEvents from '@/helper/busEvents';
import React from 'react';
import { NextRouter } from 'next/router';

export const wowSpaceMenusConfig: (
  router: NextRouter,
  t: any,
) => Array<AppMenuGroup | IAppMenuItem | string> = (router, t) => [
  {
    groupTitle: t('Originals'),
    closeMenuPanelWhenClick: true,
    requireAuth: false,
    menus: [
      {
        icon: (
          <CasinoIcon>
            <Box size={20} />
          </CasinoIcon>
        ),
        title: t('Fomo Power'),
        pathPattern: '/games/*',
        href: '/games/fomo',
      },
      {
        icon: (
          <CasinoIcon>
            <Dice3 size={20} />
          </CasinoIcon>
        ),
        title: t('Dice'),
        href: '/casino/dice',
        requireAuth: false,
      },
      {
        icon: (
          <CasinoIcon>
            <RocketLaunch fontSize="small" />
          </CasinoIcon>
        ),
        title: t('Crash'),
        href: '/casino/crash',
        requireAuth: false,
      },
    ],
  },
  'divider',
  {
    icon: (
      <CasinoIcon>
        <Flame size={20} />
      </CasinoIcon>
    ),
    title: t('Burnfi'),
    href: '/burnfi',
    requireAuth: false,
    menus: [
      {
        icon: (
          <CasinoIcon>
            <Gem size={18} />
          </CasinoIcon>
        ),
        title: t('WoW Planet Mint'),
        href: '/burnfi/palent/mint',
      },
    ],
  },
  {
    icon: (
      <CasinoIcon>
        <Gem size={20} />
      </CasinoIcon>
    ),
    title: t('Void Badge'),
    href: '/void-badge',
    requireAuth: false,
  },
  'divider',
  {
    icon: (
      <CasinoIcon>
        <Crown size={20} />
      </CasinoIcon>
    ),
    title: t('Reputation'),
    href: '/reputation',
    closeMenuPanelWhenClick: true,
  },
  {
    icon: (
      <CasinoIcon>
        <Share2 size={20} />
      </CasinoIcon>
    ),
    title: t('Referral'),
    href: '/profile/referral',
    requireAuth: true,
  },
  // {
  //   icon: (
  //     <CasinoIcon>
  //       <Coins size={20} />
  //     </CasinoIcon>
  //   ),
  //   title: t('CEFI'),
  //   href: '/cefi',
  //   closeMenuPanelWhenClick: true,
  // },
  // {
  //   icon: <SupportAgent fontSize={'small'} />,
  //   title: t('Referral'),
  //   closeMenuPanelWhenClick: true,
  //   onClick: () => {
  //     busEvents.emit('toggleZendeskStatus');
  //   },
  // },
];

export default wowSpaceMenusConfig;
